import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  ContractTransferRequestModel,
  ContractTransferListRequestModel,
  ContractTransferListResponseModel,
  ContractTransferModel,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class ContractsTransferService {
  constructor(private http: HttpClient) {}

  public initializeContractTransfer(contractId: number): Observable<ContractTransferRequestModel> {
    return this.http.get<ContractTransferRequestModel>(
      `${environment.apiEndpoint}/b2b/contracts/transfer/init/${contractId}`,
    );
  }

  public startContractTransfer(body: ContractTransferRequestModel, files?: File[]): Observable<ContractTransferModel> {
    const formData = new FormData();
    formData.append('payload', new Blob([JSON.stringify(body)], { type: 'application/json' }));

    if (files?.length) {
      files.forEach((file) => formData.append('files', file));
    }

    return this.http.post<ContractTransferModel>(`${environment.apiEndpoint}/b2b/contracts/transfer`, formData);
  }

  public getTransferByContractIdAndClientId(contractId: number, clientId: string): Observable<ContractTransferModel> {
    return this.http.get<ContractTransferModel>(`${environment.apiEndpoint}/b2b/contracts/transfer`);
  }

  public getTransferByContractId(contractId: number): Observable<ContractTransferModel[]> {
    return this.http.get<ContractTransferModel[]>(
      `${environment.apiEndpoint}/b2b/contracts/transfer/contract/${contractId}`,
    );
  }

  public getTransfersByClientId(clientId: string): Observable<ContractTransferModel> {
    return this.http.get<ContractTransferModel>(`${environment.apiEndpoint}/b2b/contracts/transfer/client/${clientId}`);
  }

  public getTransferList(request: ContractTransferListRequestModel): Observable<ContractTransferListResponseModel> {
    let params: HttpParams = new HttpParams();

    if (request?.page) {
      params = params.set('page', request.page);
    }

    if (request?.page_size) {
      params = params.set('page_size', request.page_size);
    }

    if (request?.sort_direction) {
      params = params.set('sort_direction', request.sort_direction);
    }

    if (request?.sort_by) {
      params = params.set('sort_by', request.sort_by);
    }

    if (request?.status) {
      params = params.set('status', request.status);
    }

    return this.http.get<ContractTransferListResponseModel>(
      `${environment.apiEndpoint}/b2b/contracts/transfer/advisor`,
      {
        params,
      },
    );
  }

  public getSingleTransfer(transferId: number, clientId: string): Observable<ContractTransferModel> {
    return this.http.get<ContractTransferModel>(
      `${environment.apiEndpoint}/b2b/contracts/transfer/${transferId}/client/${clientId}`,
    );
  }

  public resentExistTransfer(transferId: number): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/b2b/contracts/transfer/${transferId}/resend`, null);
  }

  public updateStatus(transferId: number, body: { status: 'SENT' | 'CONFIRMED' }): Observable<ContractTransferModel> {
    return this.http.patch<ContractTransferModel>(
      `${environment.apiEndpoint}/b2b/contracts/transfer/${transferId}/status`,
      body,
    );
  }

  // Trigger Email Reminder for Test's on DEV.
  public triggerEmailReminder(transferId: number): Observable<void> {
    return this.http.post<void>(
      `${environment.apiEndpoint}/b2b/dev/contracts/transfer/${transferId}/trigger-reminder`,
      null,
    );
  }
}
